// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  /** false = do not load Bureau / MaxMind CDNs (Verisoul only). */
  loadBureauMaxmindCdn: false,
  //  baseUrl: 'https://apisurvey2.opinionest.com/',
  baseUrl:'https://adminapibetaangular.opinionest.com/',
  // baseUrl: 'http://localhost:65231/',

  recaptcha: {
    siteKey: "6LdHcYcUAAAAADPyy7-Os-PR81Yj4pe8ZTNWIiFQ"
  },

  bureau: {
    // Credential_ID: 'b00eb694-c2e5-4e4b-a380-5ae3f0701ddc',//Exhausted
    // Credential_Password: '9bd6989e-0d23-4e06-a7e8-fda51115a739', //Exhausted
    // environment: 'SANDBOX', //Exhausted
    //     script: 'https://di.stg.bureau.id/v1.2.5/bureau-device-intelligence.js' //Exhausted

    Credential_ID: '03da9f23-b37c-4c9c-ba80-f72aa3f44106',
    Credential_Password: 'c107aafd-7e64-4614-a4e3-9f2c49617813',
    environment: 'PRODUCTION',
    script: 'https://di.prd.bureau.id/v1.2.9/bureau-device-intelligence.js'
  },
  // verisole: {
  //   project_id: '49a01d5c-794c-434d-8cd2-a482ec67a7e6',
  //   env: 'https://js.verisoul.ai/sandbox/bundle.js'
  // }
  verisole:{
    project_id:'7f70f3d3-8e0a-456c-a21d-c2779fc25f13',
    env: 'https://engage.opinionest.com/bundle.js'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
